export enum THOUGHTS {
  like = 'אהבתי',
  improvement = 'יש מה לשפר',
  problem = 'יש בעיה טכנית',
}

export enum NEW_PAGE_THOUGHTS {
  improvement = 'יש מה לשפר',
  problem = 'יש בעיה טכנית',
  other = 'אחר',
}

export enum HELPFULNESS {
  Helped = 'תרם לי מאוד',
  PartiallyHelped = 'תרם לי חלקית',
  DidNotHelp = 'לא תרם לי',
}

export enum REASONS {
  comfort = 'לא היה לי נוח',
  clarity = 'לא היה לי ברור',
  other = 'אחר',
}

export enum HELPFULNESS_RATING {
  Helped = 1,
  PartiallyHelped = 2,
  DidNotHelp = 3,
}

export enum NEW_FORM_IMPROVEMENT_AREAS {
  ImprovementRequired = 4,
  TechnicalProblem = 5,
  Other = 6,
}

export enum EXISTING_FORM_IMPROVEMENT_AREAS {
  ImprovementRequired = 4,
  TechnicalProblem = 5,
  Liked = 7,
}
export enum UNIFIED_IMPROVEMENT_AREAS {
  improvementRequired = 4,
  TechnicalProblem = 5,
  Liked = 7,
  Other = 6,
}

export enum NEGATIVE_FEEDBACK_REASONS {
  NotComfortable = 8,
  Unclear = 9,
  Other = 6,
}

export enum HELPFULNESS_RATINGS {
  Helped = 1,
  PartiallyHelped = 2,
  DidNotHelp = 3,
}

export enum DATE_RANGE {
  LastWeek = 1,
  LastMonth = 2,
  LastYear = 3,
  DateRange = 4,
}

export enum NAVIGATION_ACTION {
  BACK = -1,
  NEXT = 1,
}

export enum ORDER {
  ASCENDING = 1,
  DESCENDING = 2,
}

export enum ATTACHMENT_FILE_TYPE {
  PDF = 1,
  RECORDING = 2,
}

export enum FEEDBACK_STATUSES {
  Waiting = 1,
  Handled = 2,
  InProcess = 3,
}

export enum DEVICE_TYPE {
  IOS = 1,
  ANDROID = 2,
  PC = 3,
  OTHER = 4,
}

export enum BROWSER_TYPE {
  CHROME = 1,
  SAFARI = 2,
  EDGE = 3,
  FIREFOX = 4,
  SAMSUNG_INTERNET = 5,
  OPERA = 6,
  OTHER = 7,
}
